module.exports = __webpack_public_path__ + "img/london-ac-uk.fbed0f9.png";